<template> 
  <tr>
    <td>
      <p>{{ winner.userRank }}</p>
      <img v-if="winner.me == 'Y'" src="/images/basic/icon/icon-me.svg" alt="" srcset="">
    </td>
    <td>
      <p>{{ winner.name }}({{ winner.telNo }})</p>
      <span>{{ winner.joinDate }}</span>
    </td>
    <td>
      <p class="number">
        <span v-for="(num) in numbers" :key="num" :class="lottoList.includes(num) ? 'active' : ''">{{ num }}<span v-if="num !== numbers[numbers.length - 1]">, </span> </span>
      </p>
      <span>{{ winner.winCnt }}</span>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    winner: {
      type: Object,
      required: true
    },
    lottoList: {
      type: Array
    }
  },
  created() {
    this.numbers = this.winner.numbers.split(',')
  },
  data() {
    return {
      numbers: []
    }
  },

}
</script>

<style scoped>
table {
  width: 100%;
  margin-top: 15px;
}

table thead {
  border-top: 1px solid #CDD2DA;
  border-bottom: 1px solid #CDD2DA;
  color: #9EA3AB;
  font-size: 12px;
  height: 53px;
}

table thead tr td {
  padding-top: 12px;
}

table thead tr td:nth-child(2) {
  text-align: left;
}

table thead tr td:nth-child(3), table tbody tr td:nth-child(3) {
  text-align: right;
  padding-right: 14px;
}

table thead tr td:nth-child(1), table tbody tr td:nth-child(1){
  text-align: center;
  min-width: 40px;
}

table tbody tr{
  font-size: 12px;
  height: 60px;
}

table tbody tr td {
  padding-top: 14px;
  border-bottom: 1px solid #CDD2DA;
}

table tbody tr td span {
  color: #9EA3AB;
}

table tfoot tr td div {
  padding: 30px;
  font-size: 14px;
}
.active {
  color: #FF7100;
}
.winner_list {
  text-align: center;
  text-decoration: underline;
}
</style>